__webpack_require__.p = "https://wastehero-frontend-ls4v8bd7b-wastehero.vercel.app/";